import { Component, Input } from '@angular/core';
import { CardModel } from '@barthauer/abc/cards-view';
import { AbcCoreContainerService } from '@barthauer/abc/ui-components';
import { BceService } from './services/bce.service';

@Component({
  selector: 'bce-library',
  template: '<abc-cards-view [groupsCard]="_cardModelData" *ngIf="_cardModelData"></abc-cards-view>',
  providers: [AbcCoreContainerService],
})
export class BceComponent {
  public _cardModelData: CardModel;
  @Input() set cardModelData(data: CardModel) {
    this._cardModelData = data;
  }

  constructor(public bceService: BceService) {
    this.bceService.cardModelData.subscribe((data) => {
      this._cardModelData = data;
    });
  }
}
